(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rbst-editorial"] && !Shopify.designMode) return;
  try {
    
function rbstReveal(root) {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.animate([{opacity:0, transform:'translateY(22px)'},{opacity:1, transform:'translateY(0)'}],{duration:650,easing:'cubic-bezier(.2,.6,.3,1)'});
      observer.unobserve(entry.target);
    });
  },{threshold:.08});
  root.querySelectorAll('.collection__title, .product-grid > li, .image-banner, .multicolumn').forEach(el => observer.observe(el));
}
if (document.querySelector('.rbst-editorial')) rbstReveal(document);
document.addEventListener('shopify:section:load', event => {if(document.querySelector('.rbst-editorial')) rbstReveal(event.target);});

if (!customElements.get('rbst-product-rail')) customElements.define('rbst-product-rail', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.track = this.querySelector('.rbst-rail__track');
    this.items = Array.from(this.querySelectorAll('.rbst-rail__item'));
    if (this.items.length < 2) return;
    this.controller = new AbortController();
    const options = {signal:this.controller.signal};
    this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.paused = this.dataset.autoplay !== 'true' || this.reduced.matches;
    this.previous = this.querySelector('[data-previous]');
    this.next = this.querySelector('[data-next]');
    this.play = this.querySelector('[data-play]');
    this.index = () => this.items.reduce((best,item,index) => Math.abs(item.offsetLeft-this.items[0].offsetLeft-this.track.scrollLeft)<Math.abs(this.items[best].offsetLeft-this.items[0].offsetLeft-this.track.scrollLeft)?index:best,0);
    this.move = step => {
      const index = (this.index()+step+this.items.length)%this.items.length;
      this.track.scrollTo({left:this.items[index].offsetLeft-this.items[0].offsetLeft,behavior:this.reduced.matches?'instant':'smooth'});
    };
    const stop = () => {this.paused = true;this.updatePlay();};
    this.previous?.addEventListener('click',()=>{stop();this.move(-1);},options);
    this.next?.addEventListener('click',()=>{stop();this.move(1);},options);
    this.track.addEventListener('pointerdown',stop,options);
    this.track.addEventListener('keydown',event=>{
      if(event.key!=='ArrowRight' && event.key!=='ArrowLeft') return;
      event.preventDefault();stop();this.move(event.key==='ArrowRight'?1:-1);
    },options);
    this.play?.addEventListener('click',()=>{this.paused=!this.paused;this.updatePlay();},options);
    this.reduced.addEventListener('change',()=>{if(this.reduced.matches) stop();},options);
    this.updatePlay();
    this.visible = false;
    this.observer = new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;},{threshold:.5});
    this.observer.observe(this);
    this.timer = setInterval(()=>{
      if(!this.paused && this.visible && !document.hidden && !this.matches(':hover') && !this.contains(document.activeElement)) this.move(1);
    },5500);
  }
  updatePlay(){if(!this.play)return;this.play.textContent=this.paused?'▷':'Ⅱ';this.play.setAttribute('aria-label',this.paused?this.play.dataset.playLabel:this.play.dataset.pauseLabel);this.play.setAttribute('aria-pressed',String(this.paused));}
  disconnectedCallback(){clearInterval(this.timer);this.controller?.abort();this.observer?.disconnect();this.ready=false;}
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rbst-footer"] && !Shopify.designMode) return;
  try {
    
function rbstPrepareReviews(root) {
  root.querySelectorAll('.jdgm-carousel-wrapper').forEach(wrapper=>{
    if(wrapper.dataset.rbstReady)return;
    const track=wrapper.querySelector('.jdgm-carousel__item-wrapper');
    const previous=wrapper.querySelector('.jdgm-carousel__left-arrow');
    const next=wrapper.querySelector('.jdgm-carousel__right-arrow');
    if(!track || !previous || !next)return;
    wrapper.dataset.rbstReady='true';
    track.tabIndex=0;
    track.setAttribute('role','region');
    track.setAttribute('aria-label',wrapper.querySelector('.jdgm-carousel-title')?.textContent || 'Reviews');
    function move(direction) {
      const card=track.querySelector('.jdgm-carousel-item');
      if(!card)return;
      const gap=parseFloat(getComputedStyle(track).gap)||0;
      const end=track.scrollWidth-track.clientWidth;
      let left=track.scrollLeft+direction*(card.getBoundingClientRect().width+gap);
      if(direction>0 && track.scrollLeft>=end-3)left=0;
      if(direction<0 && track.scrollLeft<=3)left=end;
      track.scrollTo({left,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
    }
    [[previous,-1],[next,1]].forEach(([button,direction])=>{
      button.addEventListener('click',event=>{event.preventDefault();event.stopImmediatePropagation();move(direction);},true);
      button.addEventListener('keydown',event=>{if(event.key==='Enter' || event.key===' '){event.preventDefault();event.stopImmediatePropagation();move(direction);}},true);
    });
    track.addEventListener('keydown',event=>{if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();move(event.key==='ArrowLeft'?-1:1);}});
  });
}
rbstPrepareReviews(document);
const reviewRoot=document.getElementById('MainContent');
if(reviewRoot){const observer=new MutationObserver(()=>{rbstPrepareReviews(document);if(document.querySelector('.jdgm-carousel-wrapper[data-rbst-ready]'))observer.disconnect();});observer.observe(reviewRoot,{subtree:true,childList:true});setTimeout(()=>observer.disconnect(),30000);}
document.addEventListener('shopify:section:load',()=>rbstPrepareReviews(document));
function rbstFrenchWidgets() {
  if (!document.documentElement.lang.toLowerCase().startsWith('fr')) return;
  const root = document.getElementById('MainContent');
  if (!root) return;
  const labels = new Map([
    ['Complete the set', 'Complète l’ensemble'],
    ['Save 10% when you shop the set.', 'Économise 10 % en achetant l’ensemble.'],
    ['Add the set', 'Ajouter l’ensemble'],
    ['Add to cart', 'Ajouter au panier'],
    ['Discount applied at checkout.', 'Rabais appliqué au paiement.'],
    ['Discounts will be applied at checkout.', 'Rabais appliqué au paiement.'],
    ['Let customers speak for us', 'Les avis de notre communauté'],
    ['MEMBERS FEEDBACK', 'LES AVIS DE NOTRE COMMUNAUTÉ'],
    ['Original price:', 'Prix habituel :'],
    ['Current price:', 'Prix réduit :'],
    ['Original price', 'Prix habituel'],
    ['Discounted price', 'Prix réduit'],
    ['Previous reviews', 'Avis précédents'],
    ['Next reviews', 'Avis suivants']
  ]);
  const selector = '.bndlr-bundle-title,.bndlr-bundle-description,.bndlr-add-to-cart,.bndlr-bundle-checkout-warning,.bndlr-sr-only,.jdgm-carousel-title,.jdgm-carousel-number-of-reviews';
  let queued = false;
  function update() {
    queued = false;
    root.querySelectorAll(selector).forEach(el => {
      Array.from(el.childNodes).forEach(node => {
        if (node.nodeType !== Node.TEXT_NODE) return;
        const text = node.nodeValue.trim();
        const next = labels.get(text) || (/^from \d+ reviews?$/.test(text) ? text.replace(/^from (\d+) reviews?$/, 'Selon $1 avis') : null);
        if (next && text !== next) node.nodeValue = node.nodeValue.replace(text, next);
      });
    });
    root.querySelectorAll('.jdgm-carousel__left-arrow,.jdgm-carousel__right-arrow,.jdgm-carousel__item-wrapper,.bndlr-old-price,.bndlr-new-price').forEach(el => {
      const old = el.getAttribute('aria-label');
      if (labels.has(old)) el.setAttribute('aria-label', labels.get(old));
    });
    root.querySelectorAll('.bndlr-select-variant').forEach(el => {
      if (el.getAttribute('aria-label') === 'variant') el.setAttribute('aria-label', 'Taille');
    });
  }
  update();
  const observer = new MutationObserver(() => {
    if (!queued) {queued = true; requestAnimationFrame(update);}
  });
  observer.observe(root, {childList:true, subtree:true, characterData:true});
  window.addEventListener('pagehide', () => observer.disconnect(), {once:true});
}
rbstFrenchWidgets();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rbst-outfits"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rbst-outfit')) {
    customElements.define('rbst-outfit', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const form = this.querySelector('form');
        const selects = [...this.querySelectorAll('select')];
        const button = this.querySelector('button');
        const status = this.querySelector('[role=status]');
        const fr = this.dataset.locale.startsWith('fr');
        form.addEventListener('change', () => {
          if (selects.every(s => s.value)) {
            const cents = selects.reduce((sum, s) => sum + Number(s.selectedOptions[0].dataset.price), 0);
            this.querySelector('[data-total]').textContent = new Intl.NumberFormat(this.dataset.locale, {style:'currency',currency:this.dataset.currency}).format(cents / 100);
          }
        });
        form.addEventListener('submit', async event => {
          event.preventDefault();
          if (this.busy || !form.reportValidity()) return;
          this.busy = true; button.disabled = true; button.setAttribute('aria-busy','true');
          status.textContent = fr ? 'Ajout en cours…' : 'Adding…';
          try {
            const response = await fetch(this.dataset.add, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:selects.map(s=>({id:Number(s.value),quantity:1}))})});
            const data = await response.json();
            if (!response.ok) throw new Error(data.description || data.message);
            status.textContent = fr ? 'Ensemble ajouté. Ouverture du panier…' : 'Set added. Opening your cart…';
            window.location.assign(this.dataset.cart);
          } catch(error) {
            status.textContent = fr ? 'Impossible de confirmer l’ajout. Vérifie ton panier avant de réessayer.' : 'Unable to confirm the addition. Check your cart before trying again.';
            const link = document.createElement('a'); link.href = this.dataset.cart; link.textContent = fr ? ' Voir le panier' : ' View cart'; status.append(link);
            button.disabled = false; this.busy = false;
          } finally {button.removeAttribute('aria-busy');}
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
